<template lang="pug">
.container
  .ctl-row
    el-button(round type="primary" @click="onAdd") 添加用户
    el-form(ref="form" :model="form" class="form" size="small" label-width="120px" inline)
      el-form-item(label="查询角色" prop="userType")
        el-select(v-model="form.userType" @change="userTypeChange" clearable)
          el-option(v-for="item in userTypeOpt" :key="item.value" :label="item.label" :value="item.value")
      el-form-item(label="查询普通用户" prop="orderManPhoneNumber")
        el-select(v-model="form.orderManPhoneNumber" @change="ordermanChange" clearable)
          el-option(v-for="item in ordermanList" 
                    :key="item.phoneNumber" 
                    :label="item.userName" 
                    :value="item.phoneNumber")
    el-button(type="primary" @click="searchUser") 搜 索
  .tbl-wrapper
    el-table(:data="list" border stripe height="600")
      el-table-column(prop="userName" label="姓名" width="150")
      el-table-column(prop="phoneNumber" label="手机号" width="150")
      el-table-column(prop="userType" label="用户类型" width="150")
        template(slot-scope="scope")
          span {{userType[scope.row.userType]}}
      el-table-column(prop="platform" label="交易平台" width="150")
        template(slot-scope="scope")
          span {{platform[scope.row.platform]}}
      el-table-column(prop="orderManPhoneNumber" label="关联下单员电话" width="150")
      el-table-column(prop="updateTime" label="更新时间" width="150")
      el-table-column(prop="createTime" label="创建时间" width="150")
      el-table-column(prop="email" label="邮箱" width="150")
      el-table-column(prop="comments" label="用户说明" width="190")
      el-table-column(fixed="right" label="操作" width="150")
        template(slot-scope="scope")
          el-button(type="text" @click="()=>onEdit(scope.row)") 编辑
          el-button(type="text" @click="()=>onDelete(scope.row)") 删除
    .dialog-wrapper
      create-dialog(ref="createDialog")
</template>

<script>
import { getUserList, getOrdermanList, deleteUser } from 'api/user';
import { USER_TYPE, PLATFORM, USER_TYPE_OPTION } from 'const';
import createDialog from './form';
export default {
  components: {
    createDialog,
  },
  data() {
    return {
      form: {
        userType: '',
        orderManPhoneNumber: '',
      },
      list: [],
      ordermanList: [],
      userType: USER_TYPE,
      userTypeOpt: USER_TYPE_OPTION,
      platform: PLATFORM,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    getUserList().then((res) => {
      if (res.code === 0) {
        this.list = res.data;
      } else {
        this.list = [];
      }
    });
    getOrdermanList().then((res) => {
      if (res.code === 0) {
        this.ordermanList = res.data;
      } else {
        this.ordermanList = [];
      }
    });
  },
  methods: {
    userTypeChange() {
      this.form.orderManPhoneNumber = '';
    },
    ordermanChange() {
      this.form.userType = '';
    },
    async searchUser() {
      const res = await getUserList({ ...this.form }).catch((err) =>
        this.$message.error(err.msg || '筛选发生错误'),
      );
      if (res.code === 0) {
        this.list = res.data;
      } else {
        this.$message.error(res.msg || '获取用户失败');
      }
    },
    onAdd() {
      this.$refs.createDialog.open();
    },
    onEdit(model) {
      this.$refs.createDialog.open(model);
    },
    async onDelete(user) {
      this.$confirm('确认删除吗？', '提示').then(async () => {
        const res = await deleteUser({ userName: user.userName }).catch(() =>
          this.$message.error('删除用户发生错误'),
        );
        if (res.code === 0) {
          this.$message.success('删除成功');
          window.location.reload();
        } else {
          this.$message.error('删除失败');
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  // width: 80%;
  margin: 0 auto;
}
.ctl-row {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 24px;
}
.tbl-wrapper {
  margin: 0 24px;
}
</style>
